// extracted by mini-css-extract-plugin
export default {"formContainer":"vertical-form-input-field_formContainer__j4r6B","label":"vertical-form-input-field_label__Pw5iB","input":"vertical-form-input-field_input__3xM7q"};